/**
 * Single source of truth for external Apply Now / Enrolment links.
 * If the Google Form changes, update it here only.
 */
export const APPLY_GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSeTFjS-EyDputibE228lW75QCnbKZPS7c56gUtdCNYS4c4JqQ/viewform?usp=send_form";
